import {createSelector} from 'reselect';
import {useSelector} from 'react-redux';
import {labels} from '../../util/utils';
import {
	internalMembersKey,
	externalMembersKey,
	allMembersKey,
	UserLookupType,
	userRolesType
} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';

export const projectAccessGroupsSelector = (state) => state.projectTeam.accessGroups;
export const userPreferences = (state) => state.userPreferences;
export const projectEntitiesContext = (state) => state.projectTeam.projectEntities;
export const projectDetailContext = (state) => state.project;

export const loggedInUserRoleCheckSelector = (props, inputdata) => {
	const loggedInUser = useSelector((store) => getLoggedInUserAdminRole(store, props, inputdata));
	return loggedInUser;
};

// Example of create selector
const getLoggedInUserRole = (accessGroups, userPreferences, props, inputdata) => {
	// we can filter logic here

	let loggedInUserGui = userPreferences && userPreferences.gui;
	let isLoggedInUserAdmin =
		accessGroups && userPreferences ? findIfUserHasRole(accessGroups, userPreferences.gui, 'admin') : false;
	let isLoggedInUserAnyAccessGroupMember = isLoggedInUserAdmin
		? isLoggedInUserAdmin
		: accessGroups && userPreferences
		? findIfUserHasPartOfAnyAccessGroup(accessGroups, userPreferences.gui)
		: false;
	let isUserProjectOwner = findIfUserIsProjectOwner(accessGroups, userPreferences.gui);
	return {
		isLoggedInUserAdmin: isLoggedInUserAdmin,
		isLoggedInUserAnyAccessGroupMember: isLoggedInUserAnyAccessGroupMember,
		isUserProjectOwner: isUserProjectOwner
	};
};

// selector will execute if clientsSelector and allClientsSelector data changes, we can put more dependencies
export const getLoggedInUserAdminRole = createSelector(
	[projectAccessGroupsSelector, userPreferences],
	getLoggedInUserRole
);

export const projectAccessGroupsUsersSelector = (props, inputdata) => {
	const accessGroupData = useSelector((store) => getProjectAccessGroups(store, props, inputdata));
	return accessGroupData;
};

const findIfUserHasRole = (accessGroups, userId, role) => {
	let roleExist = false;
	roleExist = _.some(accessGroups, function(group) {
		let adminUser = group.users
			.filter((user) => user.userId === userId)
			.find((user) => {
				return user.roles?.includes(role);
			});

		return adminUser ? true : false;
	});

	return roleExist;
};

const findIfUserIsProjectOwner = (accessGroups, userId) => {
	let projectOwner = false;
	let groups = accessGroups.filter((group) => {
		return group.isBuiltIn;
	});

	projectOwner = _.some(groups, function(group) {
		let owner = group.users.find((user) => {
			return user.userId === userId;
		});

		return owner ? true : false;
	});

	return projectOwner;
};

const findIfUserHasPartOfAnyAccessGroup = (accessGroups, userId) => {
	let userExist = false;
	userExist = _.some(accessGroups, function(group) {
		let adminUser = group.users.find((user) => {
			return user.userId === userId;
		});

		return adminUser ? true : false;
	});

	return userExist;
};

// Example of create selector
const getAccessGroupsUsers = (
	accessGroups,
	userPreferences,
	projectEntitiesContext,
	projectDetailContext,
	props,
	inputdata
) => {
	// we can filter logic here

	let loggedInUserGui = userPreferences && userPreferences.gui;
	let isLoggedInUserAdmin =
		accessGroups && userPreferences ? findIfUserHasRole(accessGroups, userPreferences.gui, 'admin') : false;
	let isUserProjectOwner = findIfUserIsProjectOwner(accessGroups, userPreferences.gui);
	return {
		users: getMappedTeamMemberUsers(accessGroups, accessGroups, projectEntitiesContext, {
			isLoggedInUserAdmin: isLoggedInUserAdmin,
			isUserProjectOwner: isUserProjectOwner,
			loggedInUserGui: loggedInUserGui
		}),
		isLoggedInUserAdmin: isLoggedInUserAdmin,
		isUserProjectOwner: isUserProjectOwner
	};
};

export const getProjectAccessGroups = createSelector(
	[projectAccessGroupsSelector, userPreferences, projectEntitiesContext, projectDetailContext],
	getAccessGroupsUsers
);

const internalMemberFilter = (user) => {
	return user.userType && user.userType.toLowerCase() !== 'guest'.toLowerCase();
};

const externalMemberFilter = (user) => {
	return user.userType && user.userType.toLowerCase() === 'guest'.toLowerCase();
};

export const getMappedTeamMemberUsers = (accessGroups, projectEntities, filterParameter) => {
	let users = [];

	let projectOwnerGroup = accessGroups.find((x) => x.isBuiltIn);

	if (
		filterParameter.viewMemberType &&
		filterParameter.viewMemberType !== internalMembersKey &&
		filterParameter.viewMemberType !== externalMembersKey &&
		filterParameter.viewMemberType !== allMembersKey
	) {
		const group = accessGroups.find((x) => x.id === filterParameter.viewMemberType);
		return group
			? group.users.map((x) => {
					return {
						...x,
						userType: x.userType && x.userType.toLowerCase() === 'guest' ? labels.external : labels.internal,
						userTypeValue:
							x.userType && x.userType.toLowerCase() === 'guest' ? UserLookupType.External : UserLookupType.Internal,
						name: `${x.firstName.toLowerCase()}${x.lastName.toLowerCase()}`,
						entities: projectEntities
							? projectEntities.filter((entity) => {
									return filterParameter.projectOwnerGroupSelected
										? true
										: entity.accessGroups.includes(x.accessGroupId);
							  })
							: [],
						groups: filterParameter.projectOwnerGroupSelected ? accessGroups : []
					};
			  })
			: [];
	}

	let isUserMember =
		filterParameter && !_.isUndefined(filterParameter.isLoggedInUserAnyAccessGroupMember)
			? filterParameter.isLoggedInUserAnyAccessGroupMember
			: true;

	if (isUserMember) {
		_.each(accessGroups, function(groups) {
			let entities = [];
			if (projectEntities) {
				entities = projectEntities.filter((entity) => {
					return filterParameter.projectOwnerGroupSelected ? true : entity.accessGroups.includes(groups.accessGroupId);
				});
			}

			let filteredUserType = undefined;
			let filteredUsers = groups.users;
			if (!filterParameter.isUserProjectOwner && !filterParameter.isLoggedInUserAdmin) {
				let loggedUserExist = _.some(filteredUsers, (user) => {
					return user.userId === filterParameter.loggedInUserGui;
				});

				if (!loggedUserExist) {
					filteredUsers = [];
				}
			}
			filteredUserType =
				filterParameter.viewMemberType &&
				filterParameter.viewMemberType.toLowerCase() === internalMembersKey &&
				internalMemberFilter;
			if (!filteredUserType) {
				filteredUserType =
					filterParameter.viewMemberType &&
					filterParameter.viewMemberType.toLowerCase() === externalMembersKey &&
					externalMemberFilter;
			}
			if (!filteredUserType) {
				filteredUserType = () => {
					return true;
				};
			}

			filteredUsers = filteredUsers.filter((user) => {
				let result = filteredUserType(user);
				return result;
			});

			_.each(filteredUsers, function(userItem) {
				let newGroup = {};
				newGroup.accessGroupId = groups.accessGroupId;
				newGroup.groupName = groups.groupName;
				newGroup.projectId = groups.projectId;

				let user = {};
				user = users.find((usr) => {
					return usr.userId && usr.userId === userItem.userId;
				});

				if (user) {
					if (
						projectOwnerGroup &&
						projectOwnerGroup.users.find((usr) => {
							return usr.userId && usr.userId === userItem.userId;
						})
					) {
					} else {
						let userGroups = user.groups;
						if (userGroups) {
							userGroups.push(newGroup);
						}
						if (!user.entities) {
							user.entities = [];
						}
						let mergedEntities = [...new Set([...user.entities, ...entities])];
						user.entities = mergedEntities;
					}
				} else {
					user = {};
					user.firstName = `${userItem.firstName ? userItem.firstName : ''}`;
					user.lastName = `${userItem.lastName ? userItem.lastName : ''}`;
					user.name = `${userItem.firstName ? userItem.firstName.toLowerCase() : ''} ${
						userItem.lastName ? userItem.lastName.toLowerCase() : ''
					}`;
					user.userType =
						userItem.userType && userItem.userType.toLowerCase() === 'guest' ? labels.external : labels.internal;
					user.userTypeValue =
						userItem.userType && userItem.userType.toLowerCase() === 'guest'
							? UserLookupType.External
							: UserLookupType.Internal;
					user.userId = userItem.userId;
					user.emailAddress = userItem.emailAddress;
					if (
						projectOwnerGroup &&
						projectOwnerGroup.users.find((usr) => {
							return usr.userId && usr.userId === userItem.userId;
						})
					) {
						user.isProjectOwner = true;
						let mergedEntities = [...new Set([...projectEntities, ...[]])];
						user.entities = mergedEntities;
						user.groups = accessGroups;
					} else {
						user.groups = [];
						user.entities = entities;
						user.groups.push(newGroup);
					}

					users.push(user);
				}
			});
		});
	}

	users = Utility.sortListData(users, 'name');
	return users;
};

export const accessGroupsSelector = (accessGroups, filterParameter) => {
	let sortedGroups = [...accessGroups.filter((x) => !x.isBuiltIn)].sort(function(a, b) {
		return a.groupName.localeCompare(b.groupName);
	});
	if (filterParameter.isUserProjectOwner) {
		let defaultGroup = accessGroups.find((x) => x.isBuiltIn);
		let projectOwnerGroup = {...defaultGroup, groupName: labels.projectOwnersTitle};
		return [projectOwnerGroup].concat(sortedGroups);
	}
	return filterParameter.isOversightAdmin ? sortedGroups : sortedGroups.filter((x) => x.users.some((user) => user.userId === filterParameter.loggedInUserGui));
};

export const getProjectUsers = (accessGroups, filterParameter, userDetails) => {
	let users = [];
	let projectOwnerGroup = accessGroups.find((x) => x.isBuiltIn);
	_.each(accessGroups, function(groups) {
		let filteredUserType = undefined;
		let filteredUsers = groups.users;

		filteredUserType = filterParameter.viewMemberType === internalMembersKey && internalMemberFilter;
		if (!filteredUserType) {
			filteredUserType = filterParameter.viewMemberType === externalMembersKey && externalMemberFilter;
		}
		if (!filteredUserType) {
			filteredUserType = () => {
				return true;
			};
		}

		filteredUsers = filteredUsers.filter((user) => {
			let result = filteredUserType(user);
			return result;
		});

		_.each(filteredUsers, function(userItem) {
			let newGroup = {};
			newGroup.accessGroupId = groups.accessGroupId;
			newGroup.groupName = groups.groupName;
			newGroup.projectId = groups.projectId;

			let user = {};
			user = users.find((usr) => {
				return usr.userId && usr.userId === userItem.userId;
			});

			if (!filterParameter.duplicateUserAdd && user) {
				// do nothing
			} else {
				user = {};
				if (groups.isBuiltIn) {
					user.userRole = 'owner';
					user.userRolesType = userRolesType.owner;
				} else if (userItem.roles && userItem.roles.includes('admin')) {
					user.userRole = 'admin';
					user.userRolesType = userRolesType.admin;
				} else {
					user.userRole = 'teammember';
					user.userRolesType = userRolesType.teammember;
				}

				user.firstName = `${userItem.firstName ? userItem.firstName : ''}`;
				user.lastName = `${userItem.lastName ? userItem.lastName : ''}`;
				user.name = `${userItem.firstName ? userItem.firstName : ''} ${userItem.lastName ? userItem.lastName : ''}`;
				user.userType =
					userItem.userType && userItem.userType.toLowerCase() === 'guest' ? labels.external : labels.internal;
				user.userTypeValue =
					userItem.userType && userItem.userType.toLowerCase() === 'guest'
						? UserLookupType.External
						: UserLookupType.Internal;
				user.userId = userItem.userId;
				user.emailAddress = userItem.emailAddress;
				if (!userItem.initial) {
					let usrFound = userDetails.find((usr) => {
						return usr.userId == userItem.userId;
					});
					if (usrFound) {
						user.initial = usrFound.initial;
					}
				} else {
					user.initial = userItem.initial;
				}

				if (
					projectOwnerGroup &&
					projectOwnerGroup.users.find((usr) => {
						return usr.userId && usr.userId === userItem.userId;
					})
				) {
					user.isProjectOwner = true;
					user.groups = accessGroups;
				} else {
					user.groups = [];
					// user.groups.push(newGroup);
				}

				let userFound = users.find((usr) => {
					return usr.userId && usr.userId === userItem.userId && usr.userRolesType == user.userRolesType;
				});

				if (!userFound) {
					users.push(user);
				}
			}
		});
	});

	users = Utility.sortListData(users, 'name');
	return users;
};
